import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';

import omitProps from '../../../utils/omitProps';
import { querySelector } from '../../../utils';

export const GetAllUserMonthBonusesForUserMonth = gql`
  query GetAllUserMonthBonusesForUserMonthQuery($bonusMonth: String!, $supervisorId: Int) {
    user_month_bonus_users(month: $bonusMonth, supervisor_id: $supervisorId) {
      id
      user {
        id
        fullname
      }
      state
    }   
  }
`;

const marshallData = ({ data, ownProps }) => {
  const allUserMonthBonusesForUserMonth = querySelector(data, '$.user_month_bonus_users[*]', []);
  const { loading } = data;
  return {
    ...ownProps,
    data,
    loading,
    allUserMonthBonusesForUserMonth,
  };
};

const queryData = graphql(GetAllUserMonthBonusesForUserMonth, {
  props: marshallData,
});

export const queryGetAllUserMonthBonusesForUserMonthGQL = compose(
  queryData,
  omitProps(['data']),
);
